import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import SkeletonResults from './SkeletonResults';
import Loader from 'components/Loader/Loader';

const ResultLoader = ({ skeletonResultCount, isLoading, children, skeletonCardComponent }) => {
  const skeletonResultsComponent = useMemo(() => {
    const MappedSkeletonResults = () => <SkeletonResults count={skeletonResultCount} skeletonCardComponent={skeletonCardComponent} />;
    return MappedSkeletonResults;
  }, [skeletonCardComponent, skeletonResultCount]);

  return (
    <Loader isLoading={isLoading} loaderComponent={skeletonResultsComponent}>
      {children}
    </Loader>
  );
};

ResultLoader.propTypes = {
  skeletonResultCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  skeletonCardComponent: PropTypes.elementType.isRequired,
};

export default ResultLoader;
